import { Routes, Route, useLocation } from "react-router-dom";
import AppShell from "./components/Layout/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";

import DashboardPage from "./pages/Dashboard";
import AuditLogs from "./pages/AuditLogs";
import CreateWorkshop from "./pages/CreateWorkshop";
import WorkshopList from "./pages/WorkshopList";
import WorkshopDetails from "./pages/WorkshopDetails";
import UserAdminPage from "./pages/UserAdmin";
import UserMonitoringPage from "./pages/UserMonitoring";
import LoginPage from "./pages/Login";
import LogoutPage from "./pages/Logout";
import TestApiPage from "./pages/TestApi";
import ImportPage from "./pages/Import";
import WorkshopStepsPage from "./pages/WorkshopSteps";
import WorkshopMarkdownPage from "./pages/WorkshopMarkdown";
import ErrorPage from "./pages/Error";
import WorkflowList from "./pages/WorkflowList";
import WorkflowDetailsPage from "./pages/WorkflowDetails";
import ConfigurationsPage from "./pages/Configurations";
import SessionsPage from "./pages/Sessions";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "chatlio-widget": ChatlioWidgetAttributes;
    }
    interface ChatlioWidgetAttributes {
      widgetid: string;
      widgettype: string;
    }
  }
}

function AppRoutes() {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/logout';

  const routes = (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />

      <Route element={<ProtectedRoute />}>
        <Route index element={<DashboardPage />} />
        <Route path="/audit-logs" element={<AuditLogs />} />

        <Route path="/create-workshop" element={<CreateWorkshop />} />
        <Route path="/workshops" element={<WorkshopList />} />
        <Route path="/workflows" element={<WorkflowList />} />
        <Route path="/workflows/:workflowId" element={<WorkflowDetailsPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="workshop/:workshopId">
          <Route index element={<WorkshopDetails />} />
          <Route path="import" element={<ImportPage />} />
          <Route path="monitoring" element={<UserMonitoringPage />} />
          <Route path="steps" element={<WorkshopStepsPage />} />
          <Route path="md" element={<WorkshopMarkdownPage />} />
        </Route>

        <Route path="/users" element={<UserAdminPage />} />
        <Route path="/test-api" element={<TestApiPage />} />
        <Route path="/configurations" element={<ConfigurationsPage />} />
        <Route path="/error" element={<ErrorPage />} />
      </Route>
    </Routes>
  );

  if (isAuthPage) {
    return routes;
  }

  return (
    <AppShell>
      {routes}
    </AppShell>
  );
}

export default AppRoutes;
